import React, { memo } from 'react';
import BasicCellRenderer from './BasicCellRenderer';

export default props => {
  return (
    <BasicCellRenderer {...props} iconClassName='icon-calendar52' />
  );
};
